import { IGetContasPagarArquivoByIdUseCase } from "../../../presentation/useCases/read/get_contas_pagar_arquivo_by_id_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetContasPagarArquivoByIdUseCase
 */

export class GetContasPagarArquivoByIdUseCase implements IGetContasPagarArquivoByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async getContasPagarArquivoById(
    idContasPagar: number,
    nroArquivo: number,
    imageName: string,
  ): Promise<void> {
    const blob = await this.repository.getContasPagarArquivoById(idContasPagar, nroArquivo);

    if (!blob) throw new Error('Falha ao buscar dados da imagem!');

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', String(imageName));
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);

  }
}
